// src/firebaseConfig.js
import { initializeApp, getApp, getApps } from 'firebase/app';
import { getAuth, initializeAuth, inMemoryPersistence, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { Capacitor } from '@capacitor/core';



const firebaseConfig = {
  apiKey: 'AIzaSyBqNa0qTNuS0kw0HwOv2Wml37kwoAYDkR4',
  authDomain: 'blue-wire-e382b.firebaseapp.com',
  projectId: 'blue-wire-e382b',
  storageBucket: 'blue-wire-e382b.firebasestorage.app',
  messagingSenderId: '851713053047',
  appId: '1:851713053047:web:2a6a32489b847135811172',
};

// Initialize exactly once (avoid duplicate app instances)
export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Create ONE Firestore instance and export it
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  useFetchStreams: false,
});

// Keep existing imports working (alias)
export const firestore = db;

let auth;

// iOS / Android Capacitor — use safe memory persistence (localStorage is blocked)
if (Capacitor.isNativePlatform()) {
  console.log("📱 Using in-memory persistence for native platform");
  auth = initializeAuth(app, {
    persistence: inMemoryPersistence,
  });
}

// Web — use browserLocalPersistence
else {
  console.log("🌐 Using browser local persistence");
  auth = getAuth(app);

  setPersistence(auth, browserLocalPersistence)
    .then(() => console.log("🔒 Web persistence: LOCAL storage enabled"))
    .catch(err => console.error("❌ Failed to set web persistence:", err));
}

export { auth };


export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;

